
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLimitsOutsideUnder as ObiLimitsOutsideUnderElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-limits-outside-under.js';
 
 
 

 
 export const ObiLimitsOutsideUnder = createComponent({
   react: React,
   tagName: 'obi-limits-outside-under',
   elementClass: ObiLimitsOutsideUnderElement,
   events: {
     
   }
  });
 
 